<!--
Author: TangChen
Date: 2019-10-23
Desc: 银行信息
 -->
<template>
    <div :class="'view-bank-info view bg-white ' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <div class="bank-form">
            <el-form
                ref="acctInfo"
                :model="acctInfo"
                :rules="rules"
                label-width="370px"
                class="acctInfo"
                v-on:submit.native.prevent
            >
                <el-form-item label="银行账户名称：" prop="depositacctname">
                    <el-input v-model.trim="acctInfo.depositacctname" placeholder="请输入银行账户名称" />
                </el-form-item>
                <el-form-item label="银行账户号码：" prop="depositacct">
                    <el-input v-model.trim="acctInfo.depositacct" placeholder="请输入银行账户号码" :maxlength="20" />
                </el-form-item>
                <el-form-item label="支付网点：" prop="channelid">
                    <el-select
                        v-model.trim="acctInfo.channelid"
                        placeholder="请选择支付网点"
                    >
                        <el-option
                            v-for="item in bankList||[]"
                            :key="item.channelid"
                            :label="item.fullname"
                            :value="item.channelid"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="开户银行：" prop="openbank">
                    <el-select
                        v-model.trim="acctInfo.openbank"
                        filterable
                        placeholder="请选择开户银行"
                        v-on:change="refresh"
                    >
                        <el-option
                            v-for="item in openbankList||[]"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="开户银行全称：" prop="province" class="two-cols">
                    <el-select
                        v-model.trim="acctInfo.province"
                        filterable
                        placeholder="请选择省份"
                    >
                        <el-option
                            v-for="item in provinces"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        />
                    </el-select>
                    <el-select
                        v-model.trim="acctInfo.city"
                        filterable
                        :disabled="citys.length===0"
                        placeholder="请选择城市"
                    >
                        <el-option
                            v-for="item in citys"
                            :key="item.cityid"
                            :label="item.cityname"
                            :value="item.cityname"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item
                    v-if="acctInfo.openbank!=='' && acctInfo.city!==''"
                    label="开户行名称："
                    prop="bankname"
                >
                    <el-autocomplete
                        v-model.trim="acctInfo.bankname"
                        class="inline-input"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入开户行名称"
                        :maxlength="40"
                    >
                        <el-tooltip
                            slot="suffix"
                            class="item"
                            effect="info"
                            :content="infoText"
                            placement="top"
                        >
                            <el-button class="info-btn">
                                <i class="el-icon-question" />
                            </el-button>
                        </el-tooltip>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item v-if="!$store.state.login.status" label="设置交易密码：" prop="pwd">
                    <el-input v-model.trim="acctInfo.pwd" :type="pwdType" placeholder="请设置交易密码" :maxlength="16">
                        <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                    </el-input>
                </el-form-item>
                <el-form-item v-if="!$store.state.login.status" label="再次输入交易密码：" prop="pwdConfirm">
                    <el-input v-model.trim="acctInfo.pwdConfirm" :type="pwdType" placeholder="请再次输入交易密码" :maxlength="16">
                        <i slot="suffix" :class="iconCla" v-on:click="pwdTypeChange" />
                    </el-input>
                </el-form-item>
                <el-form-item class="margin-top">
                    <el-button type="yellow" class="medium" v-on:click.prevent="submitForm('acctInfo')">
                        下一步
                    </el-button>
                    <el-button class="medium" type="back" v-on:click.prevent="$router.back()">
                        返回
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--内容-->
    </div>
</template>

<script>
    import mixin from "@/assets/js/mixin";
    import navBar from "@/components/common/navBar.vue";
    import uploadFile from "./uploadFile";
    export default {
        name: "ViewBankInfo",
        components: {
            navBar
        },
        mixins: [mixin],
        data () {
            return {
                navs: [
                    {id: "1",val: "经办人信息"},
                    {id: "2",val: "基本信息"},
                    {id: "3",val: "信息登记"},
                    {id: "4",val: "银行信息",active: "1"},
                    {id: "5",val: "文件上传"},
                    {id: "6",val: "完成注册",icon: "fa fa-check"}
                ],
                openbankList: [],
                provinces: [],
                citys: [],
                infoText: "如果下拉选项中及搜索结果中没有您的开户行，请输入开户行名称或选择附近的开户行",
                pwdType: "password",
                iconCla: "fa fa-eye-slash",
                acctInfo: {
                    depositacctname: "",
                    depositacct: "",
                    openbank: "",
                    province: "",
                    city: "",
                    pwd: "",
                    pwdConfirm: "",
                    channelid: ""
                },
                bankList: [],
                branchList: [],
                oldCity: "",
                rules: {
                    depositacctname: [
                        { validator: this.$util.validateName, trigger: "blur" }
                    ],
                    depositacct: [
                        { validator: this.$util.validateBankNum, trigger: "blur" }
                    ],
                    channelid: [
                        { required: true, message: "请选择支付网点", trigger: "change" }
                    ],
                    openbank: [
                        { required: true, message: "请选择开户银行", trigger: "change" }
                    ],
                    bankname: [
                        {required: true, message: "请输入开户行名称", trigger: "change"},
                        {validator: this.$util.validateBankName, trigger: "change"}
                    ],
                    province: [
                        { required: true, message: "请选择省份", trigger: "change" }
                    ],
                    city: [
                        { required: true, message: "请选择城市", trigger: "change" }
                    ],
                    pwd: [
                        { validator: this.$util.validateTPwd, trigger: "blur" }
                    ],
                    pwdConfirm: [
                        { validator: this.$util.validateTPwd, trigger: "blur" },
                        { validator: this.confirm, trigger: "blur" }
                    ]
                }
            };
        },
        watch: {
            "acctInfo.province"(val) {
                const _this = this;
                this.$util.getCity(val, data => {
                    _this.citys = data || [];
                    let _cityObj = {};
                    let _city = "";
                    // 城市查询结果是否存在
                    if (_this.citys.length > 0) {
                        // 是否存在旧的城市选项
                        if (_this.oldCity) {
                            _cityObj = _this.citys.find(item => {
                                return item.cityname === _this.oldCity || item.cityid === _this.oldCity;
                            });
                        }
                        _city = _cityObj.cityname || _this.citys[0].cityname;
                    }
                    _this.$set(_this.acctInfo, "city", _city || "");
                });
            },
            "acctInfo.channelid"(val){
                let _this = this;
                this.openbankList = this.$cache.getDict("150003");
                this.acctInfo.openbank = "";
                let bankListArr = _this.bankList.filter(item =>{
                    return val === item.channelid;
                });
                this.openbankList = this.openbankList.filter(item => {
                    return item.subitem === bankListArr[0].banknameid;
                });
            }
        },
        mounted() {
            this.openbankList = this.$cache.getDict("150003");
            this.provinces = this.$cache.getDict("190021");
            if(this.$store.state.login.status && !this.$util.isEmpty(this.$cache.getUser().invtp)){
                return this.getHasInfo();
            }
            this.getBankInfo();
        },
        methods: {
            // 生成搜索列表
            querySearch(queryString, cb) {
                this.$util.querySearch(this, queryString, this.acctInfo.openbank, cb);
            },
            refresh(){
                this.$set(this.acctInfo,"bankname","");
                this.branchList = [];
            },
            submitForm(name) {
                const _this = this;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.refreshBank();
                    }else{
                        return false;
                    }
                });
            },
            getHasInfo(){
                const _this = this;
                this.$util.request("orgopen/refuse/info").then(res=>{
                    if(res.data){
                        sessionStorage.setItem("refuse",JSON.stringify(res.data[0]));
                        _this.initData(res.data[0]);
                    }
                });
            },
            initData(info){
                if(info.invtp){
                    const _a = info.bankname.split("市") || [];
                    const _b = (_a.length > 2 ? _a[2] : _a[1]) || "";
                    this.oldCity = info.depositcity;
                    const _x = {
                        depositacctname: info.depositacctname,
                        depositacct: info.depositacct,
                        bankname: _b,
                        channelid: info.channelid,
                        exchangebankcode: info.exchangebankcode,
                        openbank: info.banksno,
                        city: info.depositcity
                    };
                    this.acctInfo = Object.assign({},this.acctInfo,_x);
                    const _c = this.provinces.find(item=>{
                        return item.subitem === info.depositprov || item.subitemname === info.depositprov;
                    }).subitem;
                    this.$set(this.acctInfo,"province",_c);
                }
            },
            getBankInfo(){
                const _this = this;
                this.$util.request("orgopen/banklist").then(res=>{
                    _this.bankList = res.data || [];
                    if(_this.bankList.length === 0){
                        _this.$alert("基金公司未设置可用的汇款银行网点，请联系客户处理!", "开户提示", {
                            confirmButtonText: "返回",
                            type: "warning",
                            callback: () => {
                                _this.$router.replace({name: "login"});
                            }
                        });
                    }
                    _this.doBanklist(_this.bankList);
                });
            },
            doBanklist(bankList){
                let _this = this;
                for (let i = 0;i < bankList.length; i++){
                    bankList[i].fullname = bankList[i].channelname + "-" + _this.$cache.getDict("150003",bankList[i].banknameid);
                }
            },
            refreshBank(){
                const _this = this;
                let branchcode = "";

                // 获取联行号
                const _y = this.branchList.filter(branch => {
                    return branch.branchname === this.acctInfo.bankname;
                });
                if (_y && _y[0]) {
                    branchcode = _y[0].exchangecode;
                }
                const _x = this.$cache.getDict("150003",this.acctInfo.openbank);
                const y = this.$cache.getDict("190021",this.acctInfo.province);
                let _c = this.citys.find(item=>{
                    return item.cityname === _this.acctInfo.city;
                }).cityname;
                let _g = this.acctInfo.city;
                if(_g.substr(_g.length - 1) !== "市"){
                    _g += "市";
                }
                const _bankInfo = {
                    exchangebankcode: this.acctInfo.exchangebankcode || branchcode,
                    depositacctname: this.acctInfo.depositacctname,
                    depositacct: this.acctInfo.depositacct,
                    bankname: y + _g + this.acctInfo.bankname,
                    channelid: this.acctInfo.channelid || _this.bankList[0].channelid,
                    channelname: _x,
                    depositprov: this.$cache.getDict("190021",this.acctInfo.province),
                    banksno: this.acctInfo.openbank,
                    depositcity: _c,
                    tpasswd: this.$util.enc(this.acctInfo.pwd)
                };
                this.$util.request("orgopen/acct/submit",_bankInfo,"POST").then(res=>{
                    if(res.data){
                        const info = _this.$cache.getUser();
                        if(_this.$store.state.login.status && !this.$util.isEmpty(info.invtp)){
                            if(info.hasrefuse === "1" && info.refusetype === "1"){
                                this.$alert("您的账户信息已提交成功，请等待复核", "开户申请提示", {
                                    confirmButtonText: "返回首页",
                                    type: "warning",
                                    customClass: "info-check",
                                    beforeClose: (action, instance, done) => {
                                        _this.$util.request("common/logout",{},false,false).then(res => {
                                            if (res.data) {
                                                _this.$store.dispatch("logout", res.data[0]).then(() => {
                                                    _this.$router.push({name: "login"});
                                                });
                                            }
                                        });
                                        done();
                                    }
                                });
                                return;
                            }
                        }
                        this.$confirm("您已成功申请机构账户，是否立即前往开户资料上传", "开户申请提示", {
                            confirmButtonText: "立即",
                            cancelButtonText: "暂未准备好",
                            type: "warning",
                            customClass: "info-check"
                        }).then(() => {
                            _this.$router.push({name: "uploadfile"});
                        }).catch(()=>{
                            if(this.$store.state.login.status){
                                _this.$util.request("common/logout",{},false,false).then(res => {
                                    if (res.data) {
                                        _this.$store.dispatch("logout", res.data[0]).then(() => {
                                            _this.$router.push({name: "login"});
                                        });
                                    }
                                });
                            }else{
                                _this.$router.push({name: "login"});
                            }

                        });
                    }
                });
            },
            /* 确认密码校验 */
            confirm (rule, value, callback) {
                if (this.acctInfo.pwd !== this.acctInfo.pwdConfirm) {
                    callback(new Error("输入密码和确认密码不一致"));
                } else {
                    callback();
                }
            },
            /* 密码显示或隐藏处理 */
            pwdTypeChange () {
                this.pwdType = this.pwdType === "text" ? "password" : "text";
                this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
            }
        }
    };
</script>
<style lang="scss">
    .view-bank-info {
        margin-top: 5px;
        padding: 10px 55px 50px;
    .bank-form{
    .el-select{width: 50%;}
    .two-cols .el-select{width: 24%;&:last-child{margin-left: 2%;}}
    .el-autocomplete {
        width: 50%;
    .el-input {
        width: 100%;
        font-size: 16px;
    }
    .el-button.info-btn {
        border: none;
        padding: 10px 10px;
    &:hover,
    &:focus {
         background-color: transparent;
     }
    }
    }

    }
    /*颜色，背景写在css/theme.scss内views style下*/
    }
</style>
